import { SectionWrapper } from "../SectionWrapper";
import React from "react";
import { Divider, Stack, Text, useBreakpointValue } from "@chakra-ui/react";
import { BlockSectionHeader } from "../../../../../content/contentView/previewSection/BlockSectionHeader";
import { BiPlus } from "react-icons/bi";
import { sortByNumberProperty } from "../../../../components/utils";

interface StockOptionPool {
  optionPoolId: string;
  employeeCount: number;
  endDate: number;
  totalOptions: number;
}

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  stockOptionPools: StockOptionPool[];
}
export default function SectionStockOptions({ stockOptionPools, ...props }: Props) {
  const isMobile = useBreakpointValue({ base: true, md: false }, { fallback: "md", ssr: false });
  return (
    <SectionWrapper {...props}>
      <Stack width="100%" direction="row" justifyContent="space-between" paddingX={isMobile ? 2 : 4} fill="charli.primaryBlue">
        <BlockSectionHeader title="Debt Financing" />
        <BiPlus size={32} fill="inherit" />
      </Stack>
      <Stack width="100%" direction="row" alignItems="center" gap={1} paddingX={isMobile ? 2 : 4} borderBottom="1px solid lightgrey">
        <Text fontSize={14} flex={4}>
          Option Pool ID
        </Text>
        <Text fontSize={14} flex={2}>
          Employees
        </Text>
        <Text fontSize={14} flex={2}>
          End Date
        </Text>
        <Text fontSize={14} flex={3}>
          Total Options
        </Text>
      </Stack>
      <Stack
        width="100%"
        maxH={350}
        overflowY="auto"
        direction="column"
        divider={<Divider style={{ margin: 0, color: "lightgrey" }} />}
        gap={0}
        paddingX={2}
        style={{ scrollbarColor: "lightgrey transparent" }}>
        {sortByNumberProperty({ list: stockOptionPools, path: ["endDate"] }).map((optionPool) => (
          <Stack
            key={optionPool.optionPoolId}
            direction="row"
            alignItems="center"
            gap={1}
            paddingX={isMobile ? 1 : 2}
            paddingY={4}
            rounded="md"
            backgroundColor="transparent"
            transition="background 200ms ease"
            cursor="pointer"
            _hover={{ backgroundColor: "#d3d3d340" }}>
            <Text fontSize={14} flex={4} fontWeight="bold">
              {optionPool.optionPoolId}
            </Text>
            <Text fontSize={14} flex={2}>
              {optionPool.employeeCount.toLocaleString("en-US")}
            </Text>
            <Text fontSize={14} flex={2}>
              {new Date(optionPool.endDate).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}
            </Text>
            <Text fontSize={14} flex={3} fontWeight="bold">
              {optionPool.totalOptions.toLocaleString("en-US")}
            </Text>
          </Stack>
        ))}
      </Stack>
    </SectionWrapper>
  );
}
